import { useCallback, useSyncExternalStore } from 'react';

import { useFeatureFlags } from '@/components/FeatureFlagProvider';

export const useFeatureFlagEnabled = (flag: string): boolean => {
  const service = useFeatureFlags();
  const subscribe = useCallback(
    (onFlagsChange: () => void) => service.onFeatureFlags(onFlagsChange),
    [service],
  );
  return useSyncExternalStore(subscribe, () => service.isFeatureEnabled(flag));
};
